export enum Expiration {
  Never = 'Never',
  OneDay = '1 day',
  OneWeek = '1 week',
  OneMonth = '1 month',
  OneYear = '1 year',
}
